import moment from 'moment';
import {
  RAW_DATA_TAB_SET_BEFORE_RANGE_DATE,
  RAW_DATA_TAB_LOAD_DATA_RESULT,
  RAW_DATA_TAB_SET_FILTERS,
  RAW_DATA_TAB_LOAD_DATA,
  CLEAR_REDUX
} from "Redux/actionTypes";

const INIT_STATE = {
  loading: false,
  data: null,
  error: {},
  filters: {
    startDate: new Date(moment().startOf('week').toString()),
    endDate: new Date(),
    last: { id: '20', name: '20' },
    type: 'last'
  },
  beforeRangeDate: {
    startDate: new Date(moment().startOf('week').toString()),
    endDate: new Date()
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case RAW_DATA_TAB_LOAD_DATA:
      return { ...state, loading: true };

    case RAW_DATA_TAB_LOAD_DATA_RESULT:
      return { ...state, loading: false, data: action.payload };

    case RAW_DATA_TAB_SET_FILTERS:
      return { ...state, filters: action.payload }
    
    case RAW_DATA_TAB_SET_BEFORE_RANGE_DATE:
      return { ...state, beforeRangeDate: action.payload }


    case CLEAR_REDUX:
      return ["","RAW_DATA_TAB"].includes(action.payload.option)
        ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
        : { ...state }
        
    default:
      return state;
  }
};
